import { render, staticRenderFns } from "./SwiperCombine.vue?vue&type=template&id=b7b4144a&scoped=true"
import script from "./SwiperCombine.vue?vue&type=script&lang=js"
export * from "./SwiperCombine.vue?vue&type=script&lang=js"
import style0 from "./SwiperCombine.vue?vue&type=style&index=0&id=b7b4144a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.99.9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b4144a",
  null
  
)

export default component.exports